import type { Company } from '../usersApi/companies/company'
import type { Token } from '../usersApi/token/token'
import { UserPermissions } from '../usersApi/users/dto/user-permissions.dto'
import type { User } from '../usersApi/users/user'

export class Store {
    constructor() {}
    get token(): Token {
        const empty = { token: '', exp: 0, userId: null } as Token
        try {
            const res = JSON.parse(localStorage.getItem('token'))
            // "{}", "null" ou lixo no storage viravam "token=undefined" na URL (e "bearer undefined" no header) — erro 500 no servidor
            if (typeof res?.token !== 'string' || !res.token) return empty
            return res
        } catch (error) {
            return empty
        }
    }
    set token($v: Token) {
        // o logout grava new Token(), que serializa como "{}" — sem token não há o que guardar
        if (!$v?.token) {
            localStorage.removeItem('token')
            return
        }
        localStorage.setItem('token', JSON.stringify($v))
    }

    get company() {
        return JSON.parse(localStorage.getItem('company'))
    }
    set company($v: Company) {
        localStorage.setItem('company', JSON.stringify($v))
    }

    get user() {
        return JSON.parse(localStorage.getItem('user'))
    }
    set user($v: User) {
        localStorage.setItem('user', JSON.stringify($v))
    }

    get alert() {
        return JSON.parse(localStorage.getItem('alert'))
    }
    set alert($v: boolean) {
        localStorage.setItem('alert', JSON.stringify($v))
    }

    get player() {
        return JSON.parse(localStorage.getItem('player'))
    }
    set player($v: { mediaId: string; time: number }) {
        localStorage.setItem('player', JSON.stringify($v))
    }

    // modo de exibição escolhido pelo usuário nas telas de relatório (relatório/gráfico/ambos) — global,
    // não por relatório: ao trocar de relatório no menu a escolha deve continuar valendo
    get reportViewMode(): 'report' | 'report-chart' | 'chart' {
        return JSON.parse(localStorage.getItem('reportViewMode')) || 'report'
    }
    set reportViewMode($v: 'report' | 'report-chart' | 'chart') {
        localStorage.setItem('reportViewMode', JSON.stringify($v))
    }
}
